import { TextFieldProps } from '@mui/material'
import TextField from '~/src/components/mui-wrappers/styled/text-field'

const OrderingMethodsDatePickerInput = (props: TextFieldProps) => (
  <TextField {...props} color='container' size='small' />
)

export default OrderingMethodsDatePickerInput
